<script setup lang="ts">
const route = useRoute()

const slug = computed(() => {
  return route.params.nieuwsslug?.[0]
})

const { data: post } = await useAsyncData(`nieuws-s${slug.value}`, async () => {
  return await fetchContentDoc(`/nieuws/${slug.value}`)
})

if (!post.value) {
  throw createError({ statusCode: 404, statusMessage: 'Post not found', fatal: true })
}

useHead(post.value?.head || {})
useSeoMeta(post.value?.seo || {})

useOgImage(() => post.value?.title)

// const relatedPosts = computed(() => posts.value?.filter(post => post.path !== route.path).slice(0, 3))

const { data: surround } = await useAsyncData(`nieuws-surround-${slug.value}`, () => {
  return fetchNieuwsSurroundings(`/nieuws/${slug.value}`)
})

const breadcrumbs = computed(() => [
  {
    label: 'Home',
    to: '/',
    icon: 'i-heroicons-home',
  },
  {
    label: 'Nieuws',
    to: '/nieuws/',
  },
  {
    label: post.value?.title,
    to: `/nieuws/${slug.value}/`,
  },
])
</script>

<template>
  <div v-if="post">
    <!-- Page hero -->
    <div class="bg-muted border-b border-default">
      <UContainer class="py-10 lg:py-14">
        <UBreadcrumb
          :items="breadcrumbs"
          class="mb-6"
        />
        <h1 class="text-3xl lg:text-4xl font-bold tracking-[-0.015em] text-highlighted text-balance mb-3">
          {{ post.title }}
        </h1>
        <p class="text-muted text-pretty max-w-2xl">
          {{ post.description }}
        </p>
      </UContainer>
    </div>

    <UContainer>
      <UPage>
        <UPageBody class="prose">
          <MDCRenderer
            :body="post.body"
            :data="post"
            class="prose"
          />
          <div>
            <UContentSurround :surround="(surround as any)" />
          </div>
        </UPageBody>

        <template #right>
          <div class="hidden lg:block relative">
            <div class="mt-12 sticky top-24 z-10">
              <SidebarCompareAgents class="static" />
            </div>
          </div>
        </template>
      </UPage>
    </UContainer>
  </div>
</template>
